/* Brand spelling for visible text, including content inserted by review apps. */
function holyfoodsBrandText(text) {
  return String(text).replace(/(?:https?:\/\/|shopify:\/\/|mailto:)[^\s<>"']+|@holysoupbr\b|(?<![\w/@.\-])holy[\s\u00a0]*soup(?![\w/\-]|\.[a-z0-9])/gi, match => {
    if (/^(?:https?:\/\/|shopify:\/\/|mailto:)/i.test(match)) return match;
    return /^@/i.test(match) ? '@holyfoodsbr' : 'HolyFoods';
  });
}

if (typeof document !== 'undefined') {
  (() => {
    const excluded = 'script,style,noscript,textarea,input,code,pre,[contenteditable="true"]';
    function text(node) {
      if (node.parentElement?.closest(excluded)) return;
      const next = holyfoodsBrandText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
    }
    function attributes(el) {
      if (el.closest(excluded)) return;
      for (const name of ['alt','title','aria-label','placeholder']) {
        const value = el.getAttribute(name);
        if (value) {
          const next = holyfoodsBrandText(value);
          if (next !== value) el.setAttribute(name, next);
        }
      }
    }
    function scan(root) {
      if (root.nodeType === 3) { text(root); return; }
      if (root.nodeType !== 1 || root.closest(excluded)) return;
      attributes(root);
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeType === 3) text(node);
        else attributes(node);
      }
    }
    function start() {
      scan(document.body);
      const title = holyfoodsBrandText(document.title);
      if (title !== document.title) document.title = title;
      new MutationObserver(records => {
        for (const record of records) {
          if (record.type === 'characterData') text(record.target);
          else if (record.type === 'attributes') attributes(record.target);
          else record.addedNodes.forEach(scan);
        }
      }).observe(document.body, {subtree:true, childList:true, characterData:true, attributes:true, attributeFilter:['alt','title','aria-label','placeholder']});
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
    else start();
  })();
}
